import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import React from 'react';
import toast from 'react-hot-toast';

import { fetchMerchants } from 'apis/restaurant-api/merchant-admin/merchant/api';
import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';
import ErrorToastContent from 'common/components/ErrorToastContent';

type GetMerchantsState = {
  merchants: Merchant[];
  isLoading: boolean;
};

const useGetMerchantsForUser = (): GetMerchantsState => {
  const { data: merchants = [], isLoading } = useQuery(
    ['/v1/merchant-admin/merchants'],
    () => {
      return fetchMerchants();
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      onError: (error: AxiosError) => {
        toast.error(<ErrorToastContent error={error} />, { duration: Infinity });
      },
    },
  );

  return {
    merchants,
    isLoading,
  };
};

export default useGetMerchantsForUser;
